export const routes = [
  {
    label: 'Home',
    url: '/',
  },
  {
    label: 'About Us',
    url: '/about',
  },
  {
    label: 'Services',
    url: '/services',
  },
  {
    label: 'Pricing',
    url: '/pricing',
  },
  {
    label: 'FAQ’s ',
    url: '/faqs',
  },
  {
    label: 'Contact Us ',
    url: '/contact',
  },
];

export const btnData = [
  {
    label: 'Sign In',
  },
  {
    label: 'Register',
  },
];
